import { connect } from 'react-redux';
import { StateType } from '../../../../../state/state.types';

type Props = { notificationId: number };

const mapState = ({ notifications }: StateType, { notificationId }: Props) => ({
  isAlreadyRead: !!notifications.notifReadStatusMap[notificationId],
});

export const Connect = connect(mapState);
